export default function (num) {
    const hours = (num / 60);
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);

    let result = '';

    if (rhours > 0) {
        result += rhours + ' hr. ';
    }

    if (rminutes > 0) {
        result += rminutes + ' min.';
    }

    return result;
};
